import { piqureWrapper } from 'piqure';

const { provideLazy, inject } = piqureWrapper(globalThis, 'piqure.config');

export { provideLazy, inject };
